import router from '.'
import store from '../store'
import NProgress from 'nprogress' // 路由切换进度条
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// const whiteList = ['/login', '/form'] // no redirect whitelist
const whiteList = {
  names: [
    'LoginWx', 'LoginWxRedirect', 'BindWx', 'BindWxRedirect', 'WxpayQrcode', 'WxpayQrcode2', 'TplList', 'TplList2',
    'PwSpuView', 'PwOrderView', 'PwOrderMe', 'PwWxpayQrcode'
  ], // 根据路由名称匹配
  paths: [
    '/login', '/register', '/reset-password', '/rep-login', '/404', '/result'
  ], // 根据路由fullPath匹配
  // 判断路由是否包含在该配置中
  includes(route) {
    return this.names.includes(route.name) || this.paths.includes(route.path)
  }
}

router.beforeEach(async(to, from, next) => {
  if (window.event && window.event.type === 'popstate') {
    window.popstateSignal = true
  }
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  if (
    (['FormOrgCo', 'FormOrgMe', 'FormOrgAdmin', 'FormMeCo'].includes(to.name) &&
      ['FormEdit', 'FormSetting', 'FormPublish', 'FormReplyOverview', 'FormReplyStat', 'FormReplyList'].includes(from.name)) ||
    (['OrderOrg'].includes(to.name) && ['OrderView'].includes(from.name))
  ) {
    to.meta.isBack = true
  }

  // update user info if the user has logged in
  const hasUserInfo = store.getters.userInfo
  if (!hasUserInfo) {
    // get user info
    await store.dispatch('user/getUserInfo')
  }
  const hasToken = getToken()

  if (whiteList.includes(to)) {
    // 已经登录
    if (hasToken) {
      // in the free login whitelist, go directly
      if (to.path === '/login') {
        // if is logged in, redirect to the home page
        next({ path: '/' })
        return
      }
    }

    next()
    return
  } else {
    // 未登录
    if (!hasToken) {
      /* has no token*/
      // pages that do not have permission to access are redirected to the login page.

      // 避免路由循环跳转
      if (from.query.redirect === to.path) {
        NProgress.done()
        return
      }

      next(`/login?redirect=${to.path}`)
      return
    }

    // 已经登录
    // 如果不是下面的页面，先获取OrgInfo
    if (['OrgMe', 'FormMeCo', 'FormReplyList', 'FormReplyStat', 'FormReplyOverview',
      'ContactMe', 'ReplyMe', 'UserSetting', 'BindWechat'].includes(to.name) === false) {
      // get current org info or redirect to my org list
      const orgId = localStorage.getItem('bd_webapp_orgId')
      if (!orgId) {
        // 跳转到OrgMe，先进入一个Org
        next(`/org/me`)
        return
      }
      if (!store.getters.orgInfo) {
        await store.dispatch('user/getOrgInfo')
      }
    }
    next()
    return
  }
})

router.afterEach((to, from) => {
  // finish progress bar
  NProgress.done()

  // VUE单页面应用百度统计失效问题解决方法
  if (to.path) {
    window._hmt.push(['_trackPageview', '/bda' + to.fullPath])
  }
})

/*
参考：
检测是否back操作
https://stackoverflow.com/questions/51980296/detect-back-button-in-navigation-guards-of-vue-router
*/
